// extracted by mini-css-extract-plugin
export default {"userSettings_page":"UserSettings_userSettings_page__WhdpR","userSettings_group":"UserSettings_userSettings_group__Nr3Nt"};